// extracted by mini-css-extract-plugin
export var background = "_ix-6";
export var containerMedium = "_ix-0";
export var containerMicro = "_ix-2";
export var containerSmall = "_ix-1";
export var dropdown = "_ix-5";
export var dropdownLabel = "_ix-a";
export var enter = "_ix-7";
export var exitActive = "_ix-8";
export var label = "_ix-3";
export var option = "_ix-9";
export var select = "_ix-4";